import { Link, useLoaderData } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OwnerMappingsSection } from "./owner-mappings-section";
import { OwnerSyncSection } from "./owner-sync-section";

export function OwnerSyncPage() {
  const { ownerSyncHistory, mappings, mappableColumns, hubspotFields } = useLoaderData({
    from: "/_authenticated/data-sync/owners",
  }) as {
    ownerSyncHistory: any[];
    mappings: any[];
    mappableColumns: any[];
    hubspotFields: any[];
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Owner Sync"
        description="Mirror HubSpot owners to local records"
        actions={
          <Button variant="outline" size="sm" asChild>
            <Link to="/data-sync">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Data Sync
            </Link>
          </Button>
        }
      />

      <Tabs defaultValue="sync">
        <TabsList>
          <TabsTrigger value="sync">Sync</TabsTrigger>
          <TabsTrigger value="mappings">Mappings</TabsTrigger>
        </TabsList>

        <TabsContent value="sync">
          <OwnerSyncSection initialHistory={ownerSyncHistory} />
        </TabsContent>

        <TabsContent value="mappings">
          <OwnerMappingsSection
            initialMappings={mappings}
            mappableColumns={mappableColumns}
            hubspotFields={hubspotFields}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
